import React from 'react';
import PropTypes from 'prop-types';

import { Step as MUIStep } from '@material-ui/core';

export const Step = props => <MUIStep {...props} />;

Step.propTypes = {
  active: PropTypes.bool,
  classes: PropTypes.object,
  completed: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  index: PropTypes.number,
  last: PropTypes.bool
};

export default Step;
